import React from 'react'

const Icon = ({title}) => (
  <svg 
    width="100"
    height="100"
    viewBox="0 0 100 100" 
    xmlns="http://www.w3.org/2000/svg"
    className="icon navigation-icon"
  >
    <title>{title}</title>
    <circle cx="50" cy="50" r="40" stroke="currentColor" vectorEffect="non-scaling-stroke" /> 
  </svg>
)

export default Icon


// WEBPACK FOOTER //
// ./src/onboarding/nav/views/icon.jsx